import { SearchAndSelectTabProps } from "./tabs/SearchAndSelectTabProps";

/**
 * Definition of one media source for Search and Select (e.g. My media)
 */
export interface SearchAndSelectSource
    extends Pick<
        SearchAndSelectTabProps,
        | "id"
        | "dataUrl"
        | "categoryId"
        | "filters"
        | "filterMenuProps"
        | "mediaContext"
        | "creationToolsButtons"
        | "onCreationToolSelected"
        | "preCreationToolComponent"
    > {
    /** Tab source type */
    sourceType: SearchAndSelectSourceType;
    /** The label of the tab button */
    name: string;
}

export enum SearchAndSelectSourceType {
    myMedia = "myMedia",
    channel = "channel",
    sharedRepository = "sharedRepository",
    playlists = "playlists",
    multiGalleries = "multiGalleries",
    globalMedia = "globalMedia",
}
